import styled from 'styled-components';
import { COLORS } from '@/styles/colors';
import { bodySmall, monoFont } from '@/styles/typography';
import { media } from '@/styles/responsive';

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;

  ${media.tablet`
    grid-template-columns: 1fr;
  `}
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 24px;
  border: 1px solid ${COLORS.grey[400]};
  border-radius: 16px;
  background: ${COLORS.white};
`;

export const CardHead = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: auto;
  flex-wrap: wrap;
`;

export const SetupBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  padding: 32px;
  margin-bottom: 24px;
  border-radius: 16px;
  background: ${COLORS.grey[900]};
  color: ${COLORS.white};

  ${media.tablet`
    flex-direction: column;
    align-items: flex-start;
  `}
`;

export const UnreadDot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${COLORS.red[600]};
  flex-shrink: 0;
`;

export const Mono = styled.span`
  ${monoFont};
  font-size: 14px;
`;

export const LinkButton = styled.button`
  ${bodySmall};
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  font-weight: 600;
  color: ${COLORS.green[600]};
  text-align: left;
`;

export const ReplyRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  padding: 12px 16px;
  border-top: 1px solid ${COLORS.grey[400]};

  textarea {
    min-height: 40px;
    max-height: 140px;
    resize: none;
    field-sizing: content; /* grows with the text in Chromium; other browsers keep the scrollbar */
  }
`;
